import React from "react";
import Navigation from "../../../utils/components/Navigation";
import { BsPlusCircle } from "react-icons/bs";
import { AiOutlineSearch } from "react-icons/ai";
import { BiTrash } from "react-icons/bi";

const ProjectsHeader = ({
  translate,
  handleSearch,
  showModal,
  setCardView,
  canAdd,
  showDeleted,
  onShowDeletedChange,
}) => {
  return (
    <div className="projects-header">
      <Navigation
        title={translate("projects.title")}
        inputPlaceholder={translate("projects.filter_placeholder")}
        inputOnChange={handleSearch}
        iconNode={<AiOutlineSearch className="fs-5 me-2 mt-2" />}
        buttonNode={
          canAdd && (
            <p className="m-0 p-0 text-center">
              <BsPlusCircle className="fs-4 me-2" />
              {translate("projects.add_project")}
            </p>
          )
        }
        onButtonClick={showModal}
        onViewerClick={(view) => setCardView(view)}
        extraViewerNode={
          <BiTrash
            size={24}
            className={showDeleted ? "text-orange" : "text-gray"}
            onClick={() => onShowDeletedChange(!showDeleted)}
          />
        }
      />
    </div>
  );
};

export default ProjectsHeader;
